<script lang="ts">
import { defineComponent } from 'vue'
export default defineComponent({
  name: 'OriginArchiveEntry',
})
</script>
<template>
  <Form ref="formRef" :model="model" layout="vertical" scrollToFirstError>
    <Row :gutter="16">
      <Col :xxl="6" :span="12">
        <FormItem label="保管单位" name="oldInfoDepartment">
          <Input v-model:value="model.oldInfoDepartment" placeholder="请输入" allowClear />
        </FormItem>
      </Col>
      <Col :xxl="6" :span="12">
        <FormItem label="存放地址" name="oldInfoAddress">
          <Input v-model:value="model.oldInfoAddress" placeholder="请输入" allowClear />
        </FormItem>
      </Col>
      <Col :xxl="6" :span="12">
        <FormItem label="责任人" name="oldInfoPeople">
          <Input v-model:value="model.oldInfoPeople" placeholder="请输入" allowClear />
        </FormItem>
      </Col>
      <Col :xxl="6" :span="12">
        <FormItem label="联系方式" name="oldInfoPhone">
          <Input v-model:value="model.oldInfoPhone" placeholder="请输入" allowClear />
        </FormItem>
      </Col>
    </Row>
  </Form>
  <SubmitBar
    @submit="handleSubmit"
    :submitAttrs="{
      loading: submitLoading
    }"
  />
</template>

<script lang="ts" setup name="OriginArchiveEntry">
import { Form, message, Row, Col, Input } from 'ant-design-vue'
import { ref, watch } from 'vue'
import { FormItem, SubmitBar } from '-/Common/Form'
import { handleFormError } from '@/hooks/useForm'
import { API_ORIGIN_ARCHIVE_ZCH_ADD } from '@/api/originArchiveZch'
import { API_ORIGIN_ARCHIVE_ADD } from '@/api/originArchive'
const formRef = ref()
const props = withDefaults(
  defineProps<{
    data?: Record<string, any>
    isZch?: boolean
    extraParams?: Record<string, any>
  }>(),
  {
    isZch: false
  }
)
const emits = defineEmits<{
  (e: 'refresh'): void
}>()

const model = ref<Record<string, any>>({})

const setModel = () => {
  model.value = {
    /** 保管单位 */
    oldInfoDepartment: props.data?.oldInfoDepartment,
    /** 存放地址 */
    oldInfoAddress: props.data?.oldInfoAddress,
    /** 责任人 */
    oldInfoPeople: props.data?.oldInfoPeople,
    /** 联系方式 */
    oldInfoPhone: props.data?.oldInfoPhone
  }
}
watch(() => props.data, setModel, { immediate: true, deep: true })

const submitLoading = ref(false)
const handleSubmit = async () => {
  submitLoading.value = true
  try {
    await formRef.value?.validate()
    const params: any = {
      ...props.extraParams,
      ...model.value
    }
    await (props.isZch ? API_ORIGIN_ARCHIVE_ZCH_ADD : API_ORIGIN_ARCHIVE_ADD)(params)
    message.success('保存成功')
    emits('refresh')
  } catch (err) {
    handleFormError(err)
  }
  submitLoading.value = false
}
</script>
